import { Component, OnInit, OnDestroy } from '@angular/core';
import {GridOptions, ColDef, ColGroupDef, GridApi} from 'ag-grid-community';
import { ActivatedRoute } from '@angular/router';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import { takeWhile } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { IffShipmentSummaryService } from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';

@Component({
    selector: 'app-frt-iff-detail',
    templateUrl: './frt-iff-detail.component.html',
    styleUrls: ['./frt-iff-detail.component.css'],
    standalone: false
})
export class FrtIffDetailComponent implements OnInit, OnDestroy {

  private observer$ = new BehaviorSubject(true);
  frtIFFShipmentDetailResults$ = this.iffShipmentDetailsService.frtIFFShipmentDetailResult$;
  selectedIFFShipmentSummary$ =  this.iffShipmentSummaryService.selectedFRTShipmentSummary$;
  frtIFFShipmentDetailGridOptions: GridOptions = this.initializeGridOptions();
  private gridApi!: GridApi<any>;
  constructor(private route: ActivatedRoute, private iffShipmentSummaryService: IffShipmentSummaryService,
    private iffShipmentDetailsService: IffShipmentDetailsService) { }

  ngOnInit() {
    this.route.queryParams.pipe(
    takeWhile(() => this.observer$.value))
    .subscribe(
      params => {
        this.iffShipmentDetailsService.updateFRTIffShipmentDetailRequest(params['iffMasterId']);
      });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getFRTIffShipmentDetailsColumnDefs(),
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 90,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      suppressDragLeaveHidesColumns: true,
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  getFRTIffShipmentDetailsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'SCAC Code',
        field: 'scac'
      },
      {
        headerName: 'SCAC ',
        field: 'scacName'
      },
      {
        headerName: 'Agency Bureau Name',
        field: 'agencyBureauName'
      },
      {
        headerName: 'Pro Bill Number',
        field: 'proBillNumber'
      },
      {
        headerName: 'BOL',
        field: 'bolNumber'
      },
      {
        headerName: 'Invoice',
        field: 'invoiceNumber'
      },
      {
        headerName: 'Pickup Date',
        field: 'pickupDate'
      },
      {
        headerName: 'Date Paid By Agency',
        field: 'datePaidByAgency'
      },
      {
        headerName: 'Shipping',
        field: 'shippingSystem'
      },
      {
        headerName: 'Line Haul Cost',
        field: 'lineHaulCost'
      },
      {
        headerName: 'Total Accessorial Cost',
        field: 'totalAccessorialCost'
      },
      {
        headerName: 'Fuel Sur charge Received',
        field: 'fuelSurChargeReceived'
      },
      {
        headerName: 'Fuel Sur charge Completed',
        field: 'fuelSurChargeCompleted'
      },
      {
        headerName: 'Amount Subject To IFF Received',
        field: 'amountSubjectToIFFReceived'
      },
      {
        headerName: 'Amount Subject To IFF Completed',
        field: 'amountSubjectToIFFCompleted'
      },
      {
        headerName: 'IFF AmountDue Received',
        field: 'iffAmountDueReceived'
      },
      {
        headerName: 'IFF AmountDue Completed',
        field: 'iffAmountDueCompleted'
      },
      {
        headerName: 'Payment System',
        field: 'paymentSystem'
      },
      {
        headerName: 'Type Of Payment',
        field: 'typeOfPayment'
      },
      {
        headerName: 'Payment Date',
        field: 'paymentDate'
      },
      {
        headerName: 'Payment Ref Number',
        field: 'paymentRefNumber'
      },
      {
        headerName: 'Validation Status',
        field: 'validationStatus'
      },
      {
        headerName: 'Failure Reason',
        field: 'failureReason'
      }
    ];
  }

  onExport() {
    const date = new Date();
    const params = {
      fileName: 'FRT' + '-iff-detail-rates-report-' + date + '.csv',
      allColumns: true,
      columnSeparator: ','
    };
    this.gridApi.exportDataAsCsv(params)
  }
  ngOnDestroy() {
    this.observer$.next(false);
  }
}
